import React  from 'react';
import { Storage } from 'aws-amplify';
import useSnack  from 'hooks/useSnack';
import { Editor } from '@tinymce/tinymce-react';
import uuidv4 from "uuidv4";
import FormLabel from '@material-ui/core/FormLabel';

const BUCKET = process.env.REACT_APP_BUCKET;
const RichTextEditor = ({ label, name, value, onChange, placeholder, autoFocus, mceOptions }) => {
  const snack = useSnack();


  const uploadCallback = (file, name, cb) => {
    const key = uuidv4() + '-' + name;
    return Storage.put(key, file)
      .then((result) => {
        const url = `https://${BUCKET}.s3.us-east-2.amazonaws.com/public/${result.key}`;
        cb(url);
      })
      .catch((err) => {
        snack.error(err.message);
      });
  };

  mceOptions = mceOptions || {
    plugins: [],
    options: {}
  };

  return (
    <div>
      {label && (
        <FormLabel component="label">{label}</FormLabel>
      )}
      <Editor
        apiKey="vkyhsrm3rtf2qsl2ju0g465vnjs011arjgqcarcsgjomuscu"
        id={name}
        init={{
          min_height: 300,
          max_height: 600,
          auto_focus: autoFocus,
          menubar: false,
          statusbar: false,
          browser_spellcheck: true,
          relative_urls: false,
          remove_script_host: false,
          forced_root_block: false,
          contextmenu: false,
          media_live_embeds: true,
          default_link_target: "_blank",
          plugins: [
            'autolink lists link charmap anchor',
            'searchreplace visualblocks image table',
            'media paste table autoresize preview',
            ...mceOptions.plugins
          ],
          toolbar:
            'styleselect alignleft aligncenter bullist numlist forecolor backcolor link image media table preview',
          style_formats_autohide: true,
          style_formats: [
            { title: 'h1', block: 'h1' },
            { title: 'h2', block: 'h2' },
            { title: 'h3', block: 'h3' },
            { title: 'h4', block: 'h4' },
            { title: 'h5', block: 'h5' },
            { title: 'Bold', inline: 'strong' },
            { title: 'Italic', inline: 'em' },
            { title: 'Small', inline: 'small' },
            { title: 'Normal', exact: true, block: 'p' },
            {
              title: 'Responsive Image',
              selector: 'img',
              styles: { maxWidth: '100%' }
            }
          ],
          file_picker_types: 'image',
          image_description: false,
          image_dimensions: true,
          image_advtab: false,
          typeahead_urls: false,
          images_upload_handler: function(blobInfo, success, failure) {
            uploadCallback(blobInfo.blob(), blobInfo.filename(), success);
          },
          ...mceOptions.options,
        }}
        name={name}
        value={value}
        onEditorChange={onChange}
        placeholder={placeholder}
      />
    </div>
  )
};

RichTextEditor.defaultProps = {
  autoFocus: true
}

export default RichTextEditor;
